/* change later */
import { SmlAsset } from "@src/types/intelligence-search";
import React, { createContext, useContext } from "react";
import { useLoad, LoadResponse } from "../hooks/use-load";
import { useDryRun, DryRunResponse } from "../hooks/use-dry-run";
import { useSmlQueryBuilderContext } from "./sml-query-builder-context";
import { config } from "@src/config";

type SmlQueryContextType = {
    referencedAssets?: SmlAsset[];
    isLoading: boolean;

    dryRunQueryHasError: boolean;
    isDoingDryRunQuery: boolean;
    dryRunResult?: DryRunResponse;
    dryRunQueryError?: {
        statusCode: number;
        message: string[];
    } | null;
    dryRunQuery: (timeout: number) => Promise<void>;

    loadResult?: LoadResponse;
    isLoadingData: boolean;
    loadDataError: any;
    loadDataHasError: boolean;
    loadData: (timeout?: number) => Promise<any>;
};

type SmlQueryProviderProps = React.PropsWithChildren<{
    queryKey?: string;
}>;

export const SmlQueryContext = createContext({} as SmlQueryContextType);

export const SmlQueryProvider: React.FC<SmlQueryProviderProps> = ({ children, queryKey }) => {
    const { productCode, getGeneratedJsonQuery, timeRange } = useSmlQueryBuilderContext();

    const {
        data: dryRunResult,
        isLoading: isDoingDryRunQuery,
        isError: dryRunQueryHasError,
        error: dryRunQueryError,
        refetch: dryRunQuery,
    } = useDryRun({
        queryKey,
        shouldFetchData: false,
        productCode,
        jsonQuery: getGeneratedJsonQuery(),
        startDate: timeRange?.[0]?.format(config.DATE_FORMAT),
        endDate: timeRange?.[1]?.format(config.DATE_FORMAT),
    });
    const referencedAssets = dryRunResult?.ref_assets;

    const {
        loadResponse: loadResult,
        isLoading: isLoadingData,
        error: loadDataError,
        isError: loadDataHasError,
        refetch: loadData,
    } = useLoad({
        queryKey,
        shouldFetchData: false,
        productCode,
        jsonQuery: getGeneratedJsonQuery(),
        startDate: timeRange?.[0]?.format(config.DATE_FORMAT),
        endDate: timeRange?.[1]?.format(config.DATE_FORMAT),
    });

    const isLoading = isDoingDryRunQuery || isLoadingData;

    return (
        <SmlQueryContext.Provider
            value={{
                referencedAssets,
                isLoading,
                dryRunQueryHasError,
                loadResult,
                dryRunResult,
                dryRunQueryError,
                loadData,
                dryRunQuery,
                loadDataHasError,
                loadDataError,
                isDoingDryRunQuery,
                isLoadingData,
            }}
        >
            {children}
        </SmlQueryContext.Provider>
    );
};
export const useSmlQueryContext = () => useContext(SmlQueryContext);
